//****************************************************************************//
//                         DELIVERY OPTION SERVICE                           //
//****************************************************************************//

/*

ALL THE NETWORK CALLS MADE TO UPDATE OR RETRIEVE DELIVERY INFORMATION SHOULD GO HERE

*/
//COPIED FROM SCHEDULER ====== DOUBLE CHECK APIURL (change )
import { NETWORK_URLS } from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class BookingService {
  static createBooking = async (booking, token) => {
    var endpoint = NETWORK_URLS.bookings;
    
    try {
      //const dispatch = useDispatch();
      const response = await fetch(
        `${apiUrl()}${endpoint}`, {
          method: 'POST',
          headers: headerHelper(token),
          body: JSON.stringify(booking),
        }
      );
      const json = await response.json();
      return json;
    }

    catch {
      // to do: add error handling
      return [];
    }
  }
}